/**
 * Ventana de alerta del Panel People (Clappi) — pedido de KP 21/09/2026.
 *
 * Datos faltantes o pasos fallados solo "cuentan" como error para quien entra
 * dentro de la próxima semana hábil (5 días hábiles, lunes a viernes; sin
 * feriados) o entró hace menos de 7 días. Alguien que entra el 1/10 con datos
 * faltantes el 21/09 NO es un error todavía: sus pasos ni siquiera vencieron y
 * verlo en rojo confundía a People ("supuestos errores que aún ni pasan").
 *
 * La usan el cajón Errors, "Necesita atención" y el semáforo de la fila, así
 * los tres cuentan lo mismo (antes Errors miraba "futuro sin tope" y NeedsAttention
 * "últimos 7 días", y podían diferir).
 *
 * Asimetría deliberada: el DM del motor al recruiter por datos faltantes
 * (people-flow/validation.ts) sigue saliendo para CUALQUIER ingreso futuro —
 * avisar temprano a quien carga la planilla está bien; lo que no queremos es
 * que el panel de People lo muestre como error antes de tiempo.
 */
import { addBusinessDaysISO, addDaysISO, todayAR } from './dates';

export { addBusinessDaysISO };

/** Ingresos de hasta estos días atrás siguen alertando (datos que quedaron sin cargar). */
export const RECENT_DAYS = 7;
/** Ingresos de hasta estos días HÁBILES adelante ya alertan (semana hábil de preingreso). */
export const BUSINESS_DAYS_AHEAD = 5;

/** [hoy − 7 días, hoy + 5 días hábiles], en fecha de Buenos Aires, ambos inclusive. */
export function alertWindowAR(now: Date = new Date()): { from: string; to: string } {
  const today = todayAR(now);
  return { from: addDaysISO(today, -RECENT_DAYS), to: addBusinessDaysISO(today, BUSINESS_DAYS_AHEAD) };
}

/** ¿Un ingreso (ISO o 'YYYY-MM-DD') cae en la ventana de alerta? Sin fecha ⇒ no. */
export function isInAlertWindow(ingresoISO: string | null | undefined, now: Date = new Date()): boolean {
  const day = (ingresoISO ?? '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return false;
  const { from, to } = alertWindowAR(now);
  return day >= from && day <= to;
}
